import { Suspense } from 'react'
import { RouterProvider } from 'react-router'

import { SupportChatProvider } from '@/features/support/components/SupportChatProvider'

import { AppConfigGate } from './AppConfigGate'
import { BootErrorBoundary } from './BootErrorBoundary'
import { Providers } from './providers'
import { router } from './router'

/**
 * Composition root. `/app/config` resolves before the router mounts, so the
 * kill switch, the force-update gate and the feature flags are all settled
 * before a single screen renders (backend-routes.md §21).
 *
 * Everything here runs above the router, where a throw has nothing to catch it
 * and an unmounted tree is indistinguishable from a blank page — hence the
 * boundary around it.
 *
 * The support chat sits between the two: it reads the config and outlives
 * every route, and nothing in it loads until a screen opens the chat.
 */
function Booting() {
  return <div className="sx-backdrop-app min-h-dvh" />
}

export function App() {
  return (
    <Providers>
      <BootErrorBoundary>
        <Suspense fallback={<Booting />}>
          <AppConfigGate>
            <SupportChatProvider>
              <RouterProvider router={router} />
            </SupportChatProvider>
          </AppConfigGate>
        </Suspense>
      </BootErrorBoundary>
    </Providers>
  )
}
